/* ==========================================================================
   Carpetdocia — Arama çekmecesi denetleyicisi
   Tema JS'inin predictive katmanı devre dışı (data-enabled="false"); getirme,
   durum yönetimi, erişilebilirlik ve kapatma davranışı burada.
   ========================================================================== */

(function () {
  'use strict';

  var VIEWED_KEY = 'cd_viewed_products';
  var MAX_VIEWED = 8;
  var MIN_VIEWED_TO_SHOW = 1;
  var MIN_CHARS = 2;
  var DEBOUNCE = 250;
  var RESOURCE_LIMIT = 6;
  var cache = new Map();

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Türkçe duyarsız normalleştirme ---------- */

  function normalizeTr(s) {
    return String(s || '')
      .toLocaleLowerCase('tr')
      .replace(/ı/g, 'i').replace(/î/g, 'i')
      .replace(/ü/g, 'u').replace(/û/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/ş/g, 's')
      .replace(/ç/g, 'c')
      .replace(/ğ/g, 'g')
      .replace(/â/g, 'a')
      .trim();
  }

  /* ---------- tahmin sözlüğü ---------- */

  var SYNONYMS = (function () {
    var el = document.querySelector('[data-cd-synonyms]');
    if (!el) return [];
    var raw;
    try { raw = JSON.parse(el.textContent); } catch (e) { raw = el.textContent; }
    return String(raw || '').split('\n').map(function (line) {
      var parts = line.split('|');
      if (parts.length < 2) return null;
      var keys = parts[0].split(',').map(function (k) { return normalizeTr(k); }).filter(Boolean);
      var label = (parts[1] || '').trim();
      var href = (parts[2] || '').trim();
      if (!keys.length || !label) return null;
      return { keys: keys, label: label, href: href || searchUrl(label) };
    }).filter(Boolean);
  })();

  /* ---------- son incelenen ürünler ---------- */

  function readViewed() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(VIEWED_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (p) { return p && p.handle && p.url; }) : [];
    } catch (e) {
      return [];
    }
  }

  function captureViewed() {
    var el = document.querySelector('[data-cd-viewed-product]');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    if (!data || !data.handle) return;
    var list = readViewed().filter(function (p) { return p.handle !== data.handle; });
    list.unshift(data);
    try {
      window.localStorage.setItem(VIEWED_KEY, JSON.stringify(list.slice(0, MAX_VIEWED)));
    } catch (e) {
      /* gizli sekme */
    }
  }

  function productCard(p) {
    var img = p.image
      ? '<img src="' + p.image + '" srcset="' + (p.image2x || p.image) + ' 288w" sizes="72px" width="72" height="96" loading="lazy" decoding="async" alt="' + escapeHtml(p.title || '') + '">'
      : '';
    return '<li role="option" class="cd-search__product-item">' +
      '<a class="cd-search__product" href="' + p.url + '" tabindex="-1">' +
      '<span class="cd-search__thumb">' + img + '</span>' +
      '<span class="cd-search__pinfo">' +
      '<span class="cd-search__ptitle">' + escapeHtml(p.title || '') + '</span>' +
      (p.color ? '<span class="cd-search__pcolor">' + escapeHtml(p.color) + '</span>' : '') +
      (p.price ? '<span class="cd-search__pprice">' + escapeHtml(p.price) + '</span>' : '') +
      '</span></a></li>';
  }

  function searchUrl(term) {
    var base = (window.theme && window.theme.routes && window.theme.routes.search) || '/search';
    return base + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }

  function track(term, state, count) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'cd_search', search_term: term, search_results: state, search_result_count: count });
  }

  /* ---------- denetleyici ---------- */

  function CdSearch(root) {
    this.root = root;
    this.context = root.getAttribute('data-context');
    this.form = root.querySelector('form');
    this.input = root.querySelector('input[type="search"]');
    this.results = root.querySelector('#predictive-search');
    this.defaultPanel = root.querySelector('[data-cd-search-default]');
    this.screen = root.querySelector('[data-screen]');
    this.closeBtn = root.querySelector('.btn--close-search');
    this.live = root.querySelector('[data-cd-live]');
    this.scroll = root.querySelector('[data-cd-scroll]');

    if (!this.input || !this.form) return;

    this.suggestBlock = root.querySelector('[data-cd-suggest]');
    this.suggestList = root.querySelector('[data-cd-suggest-list]');

    this.navIndex = -1;
    this.controller = null;
    this.timer = null;

    this.setState(this.context === 'header' ? 'idle' : 'idle');
    this.bind();
    this.renderViewed();
  }

  CdSearch.prototype.renderViewed = function () {
    if (!this.defaultPanel) return;
    var block = this.defaultPanel.querySelector('[data-cd-viewed]');
    var ul = this.defaultPanel.querySelector('[data-cd-viewed-list]');
    if (!block || !ul) return;

    var list = readViewed();
    if (list.length < MIN_VIEWED_TO_SHOW) {
      block.setAttribute('hidden', '');
      ul.innerHTML = '';
      return;
    }
    ul.innerHTML = list.slice(0, 4).map(productCard).join('');
    block.removeAttribute('hidden');
  };

  CdSearch.prototype.renderSuggest = function (term) {
    if (!this.suggestBlock || !this.suggestList) return;
    var n = normalizeTr(term);
    if (n.length < MIN_CHARS || !SYNONYMS.length) {
      this.suggestBlock.setAttribute('hidden', '');
      return;
    }
    var hits = SYNONYMS.filter(function (row) {
      return row.keys.some(function (k) {
        return k.indexOf(n) === 0 || n.indexOf(k) === 0 || k.indexOf(n) > -1;
      });
    }).slice(0, 3);

    if (!hits.length) {
      this.suggestBlock.setAttribute('hidden', '');
      return;
    }
    this.suggestList.innerHTML = hits.map(function (h) {
      return '<li role="option"><a href="' + h.href + '" data-cd-search-term="' + escapeHtml(h.label) +
        '" tabindex="-1">' + escapeHtml(h.label) + '</a></li>';
    }).join('');
    this.suggestBlock.removeAttribute('hidden');
  };

  CdSearch.prototype.setState = function (state) {
    this.state = state;
    this.root.setAttribute('data-cd-state', state);
    this.input.setAttribute('aria-expanded', state === 'results' || state === 'default' ? 'true' : 'false');
    if (this.defaultPanel) {
      if (state === 'default') this.defaultPanel.removeAttribute('hidden');
      else this.defaultPanel.setAttribute('hidden', '');
    }
    if (this.suggestBlock && (state === 'default' || state === 'idle')) {
      this.suggestBlock.setAttribute('hidden', '');
    }
  };

  CdSearch.prototype.bind = function () {
    var self = this;

    document.addEventListener('predictive-search:open', function (e) {
      if (!e.detail || e.detail.context !== self.context) return;
      self.onOpen();
    });

    document.addEventListener('predictive-search:close', function () { self.close(); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || self.state === 'idle') return;
      if (self.context === 'header') self.close();
      else self.setState('idle');
    });

    document.addEventListener('click', function (e) {
      if (self.context === 'header' || self.state === 'idle') return;
      if (!self.root.contains(e.target)) self.setState('idle');
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function (e) { e.preventDefault(); self.close(); });
    }
    if (this.screen) {
      this.screen.addEventListener('click', function () { self.close(); });
    }

    this.input.addEventListener('input', function () {
      self.navIndex = -1;
      var term = self.input.value.trim();
      window.clearTimeout(self.timer);
      self.renderSuggest(term);
      if (term.length < MIN_CHARS) {
        self.abort();
        self.clearResults();
        self.setState('default');
        return;
      }
      self.showLoading();
      self.timer = window.setTimeout(function () { self.search(term); }, DEBOUNCE);
    });

    this.input.addEventListener('focus', function () {
      if (self.input.value.trim().length < MIN_CHARS) self.setState('default');
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var items = self.navItems();
        if (!items.length) return;
        e.preventDefault();
        self.navIndex += e.key === 'ArrowDown' ? 1 : -1;
        if (self.navIndex < 0) self.navIndex = items.length - 1;
        if (self.navIndex >= items.length) self.navIndex = 0;
        items.forEach(function (el) { el.classList.remove('cd-search__nav-active'); });
        var active = items[self.navIndex];
        active.classList.add('cd-search__nav-active');
        if (!active.id) active.id = 'cd-opt-' + self.navIndex;
        self.input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        var items2 = self.navItems();
        if (self.navIndex >= 0 && items2[self.navIndex]) {
          e.preventDefault();
          items2[self.navIndex].click();
        }
      } else if (e.key === 'Tab' && self.context === 'header') {
        self.trapFocus(e);
      }
    });

    if (window.visualViewport && this.context === 'header') {
      window.visualViewport.addEventListener('resize', function () {
        var panel = self.root.closest('.site-header__search');
        if (panel) panel.style.height = window.visualViewport.height + 'px';
      });
    }
  };

  CdSearch.prototype.trapFocus = function (e) {
    var focusables = this.form.querySelectorAll('input[type="search"], button:not([tabindex="-1"]), a[href]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  CdSearch.prototype.onOpen = function () {
    var self = this;
    window.clearTimeout(this.cleanupTimer);
    document.documentElement.classList.add('cd-search-open');
    window.setTimeout(function () {
      self.input.focus();
      self.setState(self.input.value.trim().length >= MIN_CHARS ? self.state : 'default');
    }, 120);
  };

  CdSearch.prototype.close = function () {
    var self = this;
    this.abort();
    window.clearTimeout(this.timer);
    this.root.classList.remove('is-active');
    document.documentElement.classList.remove('cd-search-open');
    document.body.classList.remove('predictive-overflow-hidden');
    document.dispatchEvent(new CustomEvent('predictive-search:close-all'));

    // İçerik, çekmece kayarken görünür kalsın; temizlik animasyon bitince
    window.clearTimeout(this.cleanupTimer);
    this.cleanupTimer = window.setTimeout(function () {
      self.clearResults();
      self.setState('idle');
    }, 280);
  };

  CdSearch.prototype.abort = function () {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  };

  CdSearch.prototype.clearResults = function () {
    if (this.results) this.results.innerHTML = '';
    this.input.removeAttribute('aria-activedescendant');
  };

  CdSearch.prototype.showLoading = function () {
    if (!this.results || this.state === 'loading') return;
    this.results.innerHTML = '<div class="cd-search__skeleton" aria-hidden="true"><span></span><span></span><span></span></div>';
    this.setState('loading');
  };

  CdSearch.prototype.search = function (term) {
    var self = this;
    var key = term.toLocaleLowerCase('tr');

    if (cache.has(key)) {
      this.render(term, cache.get(key));
      return;
    }

    this.abort();
    this.controller = new AbortController();

    var params = [
      'q=' + encodeURIComponent(term),
      'resources[limit]=' + RESOURCE_LIMIT,
      'resources[limit_scope]=each',
      'resources[type]=query,product,collection',
      'resources[options][unavailable_products]=last',
      'resources[options][fields]=title,product_type,variants.title,vendor,tag,body',
      'section_id=search-results'
    ].join('&');

    var route = (window.theme && window.theme.routes && window.theme.routes.predictiveSearch) || '/search/suggest';

    fetch(route + '?' + params, { signal: this.controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-search-results');
        var markup = section ? section.innerHTML : '';
        cache.set(key, markup);
        if (self.input.value.trim().toLocaleLowerCase('tr') === key) self.render(term, markup);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.clearResults();
        self.setState('default');
      });
  };

  CdSearch.prototype.render = function (term, markup) {
    if (!this.results) return;
    this.results.innerHTML = markup;
    this.setState('results');
    this.navIndex = -1;

    // Shopify'ın koleksiyon sonuçlarıyla çakışan kendi önerilerimizi at
    if (this.suggestBlock && !this.suggestBlock.hasAttribute('hidden')) {
      var resultLabels = Array.prototype.map.call(
        this.results.querySelectorAll('.cd-search__list a'),
        function (a) { return normalizeTr(a.textContent); }
      );
      Array.prototype.forEach.call(this.suggestList.querySelectorAll('li'), function (li) {
        var t = normalizeTr(li.textContent);
        if (resultLabels.indexOf(t) > -1) li.remove();
      });
      if (!this.suggestList.children.length) this.suggestBlock.setAttribute('hidden', '');
    }

    var box = this.results.querySelector('[data-cd-result-count]');
    var count = box ? parseInt(box.getAttribute('data-cd-result-count'), 10) : 0;
    if (this.live) this.live.textContent = count > 0 ? count + ' ' + (window.theme && window.theme.strings && window.theme.strings.searchResults || 'sonuç') : '';
    track(term, count > 0 ? 'found' : 'none', count);

    if (this.scroll) this.scroll.scrollTop = 0;
  };

  CdSearch.prototype.navItems = function () {
    var scope = this.state === 'default' ? this.defaultPanel : this.results;
    if (!scope) return [];
    return Array.prototype.filter.call(scope.querySelectorAll('a[href]'), function (el) { return el.offsetParent !== null; });
  };

  /* ---------- kurulum ---------- */

  function relocateDrawer() {
    var container = document.querySelector('.site-header__search-container');
    if (!container) return;
    if (container.parentElement !== document.body) document.body.appendChild(container);
    if (container.dataset.cdBound) return;
    container.dataset.cdBound = '1';
    container.addEventListener('click', function (e) {
      var panel = container.querySelector('.site-header__search');
      if (panel && !panel.contains(e.target)) {
        var ps = container.querySelector('predictive-search');
        if (ps && ps.cdSearch) ps.cdSearch.close();
      }
    });
  }

  function init() {
    captureViewed();
    relocateDrawer();
    document.querySelectorAll('predictive-search[data-cd-enhanced]').forEach(function (el) {
      if (el.cdSearch) return;
      el.cdSearch = new CdSearch(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
